// extracted by mini-css-extract-plugin
export default {"chapterImage":"Chapter_chapterImage__N1ZdO","chapterItem":"Chapter_chapterItem__UJIkU"};